import React from 'react';
import { BusinessInquiries, Connect, KnowledgeBase, LiveSupport, PressInquiries } from '@gik/contact';
import { useBemCN } from '@gik/core/utils/bemBlock';
import { PageSection } from '@gik/ui';
import { ContactForm } from '@gik/contact/components/ContactForm/ContactForm';

export default function Contact() {
  const bem = useBemCN('contact');

  return (
    <PageSection {...bem()}>
      <div {...bem('form')}>
        <ContactForm />
      </div>
      <div {...bem('tiles')}>
        <LiveSupport />
        <KnowledgeBase />
        <Connect />
        <BusinessInquiries />
        <PressInquiries />
      </div>
    </PageSection>
  );
}
